import React from "react";
import TreeItem from "@material-ui/lab/TreeItem";

import TreeItemLabel from "./TreeItemLabel";
import TreeItemBottom from "./TreeItemBottom";

const TreeItemMiddle = ({
  nodes,
  selected,
  getOnChange,
  isOpenNestedParent,
  setIsOpenNestedParent,
}) => {
  const { id, children } = nodes;

  return (
    <TreeItem
      key={id}
      nodeId={id}
      label={
        <TreeItemLabel
          nodes={nodes}
          selected={selected}
          getOnChange={getOnChange}
          setIsOpenNestedParent={setIsOpenNestedParent}
        />
      }
      onClick={() => {
        isOpenNestedParent[0] === id
          ? setIsOpenNestedParent([])
          : setIsOpenNestedParent([id]);
      }}
    >
      {
        // Render only 1 element for correct tree build
        <TreeItemBottom
          key={children[0].id}
          nodes={children[0]}
          selected={selected}
          getOnChange={getOnChange}
        />
      }
      {
        // Render all items except 1 if clicked parent node
        isOpenNestedParent[0] === id &&
          children.length > 1 &&
          children.map((node, i) => {
            if (i === 0) return null;
            return (
              <TreeItemBottom
                key={node.id}
                nodes={node}
                selected={selected}
                getOnChange={getOnChange}
              />
            );
          })
      }
    </TreeItem>
  );
};

export default TreeItemMiddle;
